import * as React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { IoMedkitOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useCurrentCase } from "duck";
import { isRequiredInfoFilled } from "../../../../../../duck";

interface EmergencyDrugsProps extends ButtonProps {
  iconOnly?: boolean;
}

const EmergencyDrugs: React.FC<EmergencyDrugsProps> = ({
  iconOnly,
  ...props
}) => {
  const infoFilled = useCurrentCase(medCase =>
    isRequiredInfoFilled(medCase?.data)
  );

  return (
    <Button
      size="sm"
      disabled={!infoFilled}
      onClick={e => {
        if (!infoFilled) {
          e.preventDefault();
        }
      }}
      to="emergency-drugs"
      as={Link}
      leftIcon={iconOnly ? undefined : <IoMedkitOutline />}
      colorScheme="red"
      {...props}
    >
      {iconOnly ? <IoMedkitOutline /> : "Emergency Drugs"}
    </Button>
  );
};

export default EmergencyDrugs;
